module.exports = __webpack_public_path__ + "img/60.ac91a01c.jpg";